export enum SplashType {
    None = "1",
    Color = "2",
    Linear = "3",
    Radial = "4",
}
